import React, { useState } from 'react';
import { Button, Input, Typography } from 'antd';
import { LeftOutlined } from '@ant-design/icons';
import Title from 'antd/es/typography/Title';
import styles from './index.module.css';
import { budgetCategoriesMapping } from '../../Utils/utils';
const { Text } = Typography;

type Props = {
  setIsModalOpen: (arg0: boolean) => void;
  addBudget: (budget: any) => void;
};

const Budget = ({ setIsModalOpen, addBudget }: Props) => {
  const categoryList = [
    'Transfers',
    'Restaurants',
    'Fuel',
    'Travel',
    'Healthcare',
    'Groceries',
  ];

  const [selectedCategory, setSelectedCategory] = useState<string | null>(null);
  const [budget, setBudget] = useState<any>();

  const handleCategoryClick = (key: string) => {
    setSelectedCategory(key);
  };

  const handleSubmitClick = () => {
    setIsModalOpen(false);
    addBudget({ name: selectedCategory, budget, spend: 0 });
  };
  const validateNumInput = (e: any) => {
    setBudget(e.target.value.replace(/[^0-9\.]+/g, ''));
  };
  return (
    <div style={{ display: 'flex', justifyContent: 'center' }}>
      <div className={styles.budget_container}>
        <Title level={3}>Add Budget</Title>
        <div style={{ paddingTop: 10 }}>
          <Typography>
            <Text>Select Category</Text>
          </Typography>
          <div style={{ paddingTop: 10 }}>
            <div
              style={{
                display: 'flex',
                overflowX: 'auto',
                flexWrap: 'wrap',
                scrollbarWidth: 'none',
                maxHeight: '120px',
              }}
            >
              {Object.keys(budgetCategoriesMapping).map((key) => (
                <Button
                  key={key}
                  className={`${styles.categoryButton} ${
                    selectedCategory === key ? styles.selected : ''
                  }`}
                  onClick={() => handleCategoryClick(key)}
                >
                  {budgetCategoriesMapping[key]}
                </Button>
              ))}
            </div>
          </div>
        </div>
        <div style={{ paddingTop: 20 }}>
          <Typography>
            <Text>Add your budget</Text>
          </Typography>
          <div style={{ paddingTop: 10 }}>
            <div className={styles.inputContainer}>
              <Input
                className={styles.budgetInput}
                prefix={
                  <Text style={{ color: 'black', marginRight: 5 }}>₹</Text>
                }
                value={budget}
                // onChange={(e) => setBudget(e.target.value)}
                placeholder='Budget Ex. 5000'
                size='middle'
                type='text'
                onInput={(e) => {
                  validateNumInput(e);
                }}
              />
            </div>
          </div>
          <div className={styles.submitContainer}>
            <Button
              type='primary'
              className={styles.primaryButton}
              style={{
                marginLeft: 'auto',
                marginRight: 'auto',
                marginTop: 16,
                display: 'flex',
              }}
              onClick={handleSubmitClick}
            >
              Submit
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Budget;
